import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getApiBaseUrl } from '../config';

const API_BASE_URL = getApiBaseUrl();

const AccountPageSimple = () => {
  const location = useLocation();
  const [result, setResult] = useState('');
  
  useEffect(() => {
    const testToken = async () => {
      console.log('=== TESTE SIMPLES ===');
      
      const urlParams = new URLSearchParams(location.search);
      const token = urlParams.get('token');
      
      console.log('Token:', token);
      console.log('API_BASE_URL:', API_BASE_URL);
      
      if (!token) {
        setResult('Token não encontrado na URL');
        return;
      }
      
      try {
        // Usar FormData para enviar como application/x-www-form-urlencoded
        const formData = new URLSearchParams();
        formData.append('token', token);
        
        console.log('FormData:', formData.toString());
        
        const response = await fetch(`${API_BASE_URL}/users/verify_token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formData.toString(),
        });
        
        console.log('Status:', response.status);
        const text = await response.text();
        console.log('Response text:', text);
        
        setResult(`Status: ${response.status}, Response: ${text}`);
        
      } catch (error) {
        console.error('Erro:', error);
        setResult(`Erro: ${error.message}`);
      }
    };
    
    testToken();
  }, [location.search]);
  
  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>Teste Simples da API</h1>
      <p><strong>URL:</strong> {location.search}</p>
      <p><strong>Resultado:</strong></p>
      <pre>{result}</pre>
    </div>
  );
};

export default AccountPageSimple; 